import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import './vm-video-comments-list-item';
import Styles from './vm-video-comments-list.scss';

/**
 * Presentational wrapper that renders its slotted children inside a `<ul
 * class="comments__list">` and carries the list's SCSS module. The parent
 * organism composes `<vm-video-comments-list-item>` children directly in
 * its own render and threads every prop (`comment`, `videoSlug`,
 * `dataAddCommentsPerm`, `openReplies`, `isDesktop`, …) to each item —
 * this element does not read, forward, or observe any of them.
 * Empty-state gating is the organism's concern: don't render the list at
 * all when there are no items.
 */
@customElement('vm-video-comments-list')
export class VmVideoCommentsList extends LitElement {
    static override styles = Styles;

    override render() {
        return html`<ul class="comments__list">
            <slot></slot>
        </ul>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-video-comments-list': VmVideoCommentsList;
    }
}
